import React, { useState, useEffect } from 'react';
import { iFollowupItem } from 'interfaces/iFollowupItem';
import { useSnackbar } from 'notistack';

interface FollowupInputProps {
  followupItems: iFollowupItem[];
  onSubmitFollowup: (followupResponses: iFollowupItem[]) => void;
  isStreaming: boolean;
}

const FollowupInput: React.FC<FollowupInputProps> = ({ followupItems, onSubmitFollowup, isStreaming }) => {
  const [ responses, setResponses ] = useState<Record<string, string>>({});
  const { enqueueSnackbar } = useSnackbar();

  // Initialize responses state with followupItems
  useEffect(() => {
    const initialResponses = followupItems.reduce((acc, item) => {
      acc[item.question] = item.answer || '';
      return acc;
    }, {} as Record<string, string>);
    setResponses(initialResponses);
  }, [ followupItems ]);

  const handleChange = (key: string, value: string) => {
    setResponses((prev) => ({ ...prev, [key]: value }));
  };

  const handleSubmit = () => {
    const arr: iFollowupItem[] = [];

    const isValid = Object.entries(responses).every(([ question, answer ]) => {
      if (answer === '') {
        enqueueSnackbar('Please input something to classify', { variant: 'error' });
        return false;
      }
      arr.push({ question: question, answer: answer });
      return true;
    });

    if (!isValid) {
      return;
    }
    onSubmitFollowup(arr);
  };

  const handleEnterPress = (e: any) => {
    if (e.key === 'Enter' || e.which === 13) {
      handleSubmit();
    }
  };

  const cleanQuestion = (text: string): string => {
    if (text.startsWith('Chapter') && text.includes(' - ')) {
      const dashIndex = text.indexOf(' - ');
      return text.slice(dashIndex + 3).trim(); // +3 to skip " - "
    }
    return text.trim();
  };


  return (
    <>
      <div className='classify-body'>
        {followupItems.map(({ question }, index) => (
          <div key={index} style={{ width: '100%' }}>
            <div className='classify-header'>
              {cleanQuestion(question)}
            </div>
            <div className='classify-cont'>
              <div className='classify-cont-sec'>
                <div className='classify-cont-sec-div'>
                  <input
                    placeholder='Enter details'
                    className='classify-cont-sec-input'
                    type='text'
                    value={responses[question] || ''}
                    onChange={(e) => handleChange(question, e.target.value)}
                    onKeyUp={handleEnterPress}
                  />
                </div>
              </div>
            </div>

          </div>
        ))}
      </div>
      {
        isStreaming ? (
          <div className='classify-footer'>
            <div className='classify-footer-btn-loading'>
              <div className='classify-footer-btn-div'>
              Reasoning...
              </div>
            </div>
          </div>
        ) : (
          <div className='classify-footer'>
            <div className='classify-footer-btn' onClick={handleSubmit} aria-disabled={isStreaming}>
              <div className='classify-footer-btn-div'>
            Submit Feedback
              </div>
            </div>
            <div className='classify-footer-txt'>
          or press Enter
            </div>
          </div>
        )
      }
    </>
  );
};

export default FollowupInput;
